import React, { PureComponent } from 'react';
import classNames from 'classnames';

import Toggle, { ToggleProps } from './Toggle';
import Menu, { MenuProps } from './Menu';
import MenuDivider from './MenuDivider';
import MenuItem from './MenuItem';
import MenuHeader from './MenuHeader';

import styles from './Dropdown.module.scss';

/*
https://github.com/trendmicro-frontend/react-dropdown/tree/master/src
https://react.semantic-ui.com/modules/dropdown/ (https://toster.ru/q/466407)

*/

interface DropdownState {
  isOpen: boolean;
}

interface DropdownProps {
  className?: string;
  dropup?: boolean;
  pullRight?: boolean;
}

// interface DropdownComponent {
//   Toggle: typeof Toggle;
//   Menu: typeof Menu;
//   MenuDivider: typeof MenuDivider;
//   MenuItem: typeof MenuItem;
//   MenuHeader: typeof MenuHeader;
// }

// const Dropdown: DropdownComponent = props => {
class Dropdown extends PureComponent<
  DropdownProps & React.HTMLAttributes<HTMLDivElement>,
  DropdownState
> /* implements DropdownComponent */ {
  static Toggle = Toggle;
  static Menu = Menu;
  static MenuDivider = MenuDivider;
  static MenuItem = MenuItem;
  static MenuHeader = MenuHeader; // Title
  // MenuGroup

  private readonly containerEl: React.RefObject<HTMLDivElement>;

  constructor(props: any) {
    super(props);
    this.containerEl = React.createRef();
    this.state = {
      isOpen: false,
    };
  }

  public componentDidMount() {
    document.addEventListener('click', this.handleClickOutside);
  }

  public componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  }

  private handleClickOutside = (event: any) => {
    const { isOpen } = this.state;
    if (!isOpen) return;
    // console.log(isOpen, event);
    // @ts-ignore
    if (this.containerEl.current && !this.containerEl.current.contains(event.target)) {
      this.setState({ isOpen: false });
    }
  };

  public handleToggle = () => {
    const { isOpen } = this.state;
    this.setState({ isOpen: !isOpen });
  };

  public render() {
    const { isOpen } = this.state;
    const { children, className, dropup, pullRight, ...restProps } = this.props;

    return (
      <div className="dropdown-root">
        <div
          className={classNames(
            styles.container,
            {
              [styles.dropup]: dropup,
              [styles.pullRight]: pullRight,
            },
            className
          )}
          ref={this.containerEl}
          {...restProps}
        >
          {React.Children.map(children, child => {
            if (!React.isValidElement(child)) {
              return null;
            }
            // <Toggle>
            if (child.type === Toggle) {
              return React.cloneElement<ToggleProps>(child, {
                ...child.props,
                isOpen,
                handleToggle: this.handleToggle,
              });
              // <Menu>
            } else if (child.type === Menu) {
              return React.cloneElement<MenuProps>(child, {
                ...child.props,
                isOpen,
                // handleToggle: this.handleToggle,
              });
            } else {
              return null;
            }
          })}
        </div>
      </div>
    );
  }
}

export default Dropdown;
